module.exports = ".loader { width: 60px; margin: 0 auto; position: relative; top: 50px; }\n.card { height: 130px; }\np { margin-top: 40px; margin-left: -10px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/spinner/spinner.component.css
// module id = ./src/app/modules/shared/spinner/spinner.component.css
// module chunks = main